import React, { FC, useEffect, useState } from "react";
import { Input, Button, Modal, Row, Col, Calendar } from "antd";
import _ from "lodash";
import { useDispatch } from "react-redux";
import moment from "moment";

const RSVPRespModal: FC<{ onClose?: () => void; rsvp?: any }> = ({
  onClose,
  rsvp,
}) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();
  const handleOptionClick = (option: string) => {
    dispatch({
      type: "SEND_MESSAGE",
      payload: {
        message: `${rsvp.data.rsvpTitle} ${option}`,
        type: "rsvp-response",
        data: {
          response: option,
          responseTo: rsvp.id,
        },
      },
    });
    handleCancel();
  };

  const handleCalendarClick = (option: any) => {
    dispatch({
      type: "SEND_MESSAGE",
      payload: {
        message: `Scheduled on: ${option.format("MM/DD/YYYY")}`,
        type: "rsvp-response",
        data: {
          response: option.toDate().getTime(),
          responseTo: rsvp.id,
        },
      },
    });
    handleCancel();
  };

  return (
    <Modal
      title={!rsvp ? "Add RSVP" : ""}
      visible={isModalVisible}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row className="mt-4 mb-4">
        <span>{rsvp.data.rsvpTitle}</span>
      </Row>

      {(rsvp.data.type === "threeButtons" || rsvp.data.type === "yes-no") &&
        <Row className="tiles">
          <Col span={24}>
            <Row className="d-flex mb-4">
              <Col span={12} className="pr-2">
                <Button
                  onClick={() => {
                    handleOptionClick(rsvp.data.options.option1);
                  }}
                  className="beam-btn green-btn cover w-full"
                >
                  {rsvp.data.options.option1}
                </Button>
              </Col>
              <Col span={12} className="pl-2">
                <Button
                  onClick={() => {
                    handleOptionClick(rsvp.data.options.option2);
                  }}
                  className={`beam-btn w-full ${
                    !rsvp.data.options.option3 ? "cover orange-btn" : ""
                  }`}
                >
                  {rsvp.data.options.option2}
                </Button>
              </Col>
            </Row>
            <Row>
              {rsvp.data.options.option3 && (
                <Col span={24}>
                  <Button
                    onClick={() => {
                      handleOptionClick(rsvp.data.options.option3);
                    }}
                    className="beam-btn orange-btn cover w-full"
                  >
                    {rsvp.data.options.option3}
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      }


      {rsvp.data.type === "calendar" && 
        <Row className="tiles">
          <Calendar fullscreen={false} validRange={[moment(rsvp.data.startDate), moment(rsvp.data.endDate)]} onSelect={(date)=>{
            console.log('on date selected', date);
            handleCalendarClick(date)
          }} />
        </Row>
      }
    </Modal>
  );
};

export default RSVPRespModal;
